import React, { useContext, useState } from "react";
import { Form, Input, Button, Upload  } from "antd";
import { UploadOutlined } from "@ant-design/icons";
import { ModalContext } from "context/ModalContext";
import { show_toast } from "utils/helpers";
import { add_sales_rep } from "services/apiSrv";
import { useMutation } from "react-query";

export default function AddSalesRepForm() {
  const { modalClose } = useContext(ModalContext);
  const [form] = Form.useForm();

   const [fileList, setFileList] = useState([]);

  const _addSalesRep = useMutation(add_sales_rep, {
    onSuccess: (data) => {
      console.log("THE DATA FROM USE MUTATION", data);
      modalClose();
      show_toast("Sales Rep added successfully", "success");
    },
    onError: async (error) => {
      modalClose();
    },
  });
  const onFinish = (values) => {
    console.log("ZE ZE VALUES", values);
       // Include the image file in the values if it exists
    const formData = { ...values };
    if (fileList.length > 0) {
      formData.image = fileList[0].originFileObj;
    }

    _addSalesRep.mutate(values);
  };

  const onFinishFailed = (errorInfo) => {
    console.log("Failed:", errorInfo);
  };

    // Handle file upload changes
  const handleUploadChange = ({ fileList: newFileList }) => {
    setFileList(newFileList);
  };

  // Custom upload props
  const uploadProps = {
    onChange: handleUploadChange,
    beforeUpload: () => false, // Prevent automatic upload
    fileList,
    accept: "image/*",
    maxCount: 1, // Allow only one image
  };


  return (
    <Form
      form={form}
      layout="vertical"
      name="add_sales_rep_form"
      onFinish={onFinish}
      onFinishFailed={onFinishFailed}
    >
      <Form.Item
        label="Sales Rep Name"
        name="name"
        rules={[
          {
            required: true,
            message: "Please input a name!",
          },
        ]}
      >
        <Input />
      </Form.Item>
      <Form.Item
        label="Sales Rep Email"
        name="email"
        rules={[
          {
            required: true,
            type: "email",
            message: "The input is not valid E-mail!",
          },
        ]}
      >
        <Input />
      </Form.Item>
      <Form.Item
        label="Sales Rep Pin"
        name="pin"
        rules={[
          {
            required: true,
            message: "Please input a Pin!",
          },
        ]}
      >
        <Input />
      </Form.Item>
            <Form.Item
        label="Profile Image"
        name="image"
        rules={[
          {
            validator: (_, value) =>
              fileList.length > 0
                ? Promise.resolve()
                : Promise.reject(new Error("Please upload an image!")),
          },
        ]}
      >
        <Upload {...uploadProps}>
          <Button icon={<UploadOutlined />}>Upload Image</Button>
        </Upload>
      </Form.Item>
      <Form.Item>
        <Button
          htmlType="submit"
          type="primary"
          block
          loading={_addSalesRep.isLoading}
        >
          Submit
        </Button>
      </Form.Item>
    </Form>
  );
}
